import { render, staticRenderFns } from "./InventoryAddMultipleItemsOverlay.vue?vue&type=template&id=97a8106a&"
import script from "./InventoryAddMultipleItemsOverlay.vue?vue&type=script&lang=ts&"
export * from "./InventoryAddMultipleItemsOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports